import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import fr from 'vuetify/lib/locale/fr';

Vue.use(Vuetify);

export const vuetify = new Vuetify({
  // Vuetify's own texts ("Sort by", "No data available"); util/i18n/localize.js
  // switches the language along with the app's.
  lang: {
    locales: { fr },
  },
  theme: {
    themes: {
      light: {
        primary: '#253765',
        secondary: '#717d9b',
        accent: '#0076ec',
        error: '#f15757',
        info: '#0076ec',
        success: '#2ecc71',
        warning: '#ffa058',
      },
      dark: {
        primary: '#253765',
        secondary: '#717d9b',
        accent: '#0076ec',
        error: '#f15757',
        info: '#0076ec',
        success: '#2ecc71',
        warning: '#ffa058',
      },
    },
  },
});
